
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/press",
      function () {
        return require("private-next-pages/media/press/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media/press"])
      });
    }
  